/* Sabor da Terra — "Um universo feito de sabor"
   Animações premium e sutis: só transform/opacity, rAF, sem bibliotecas.
   Tudo é desligado em prefers-reduced-motion; parallax só em telas largas. */
(function () {
  'use strict';
  var doc = document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia('(min-width: 901px)');
  var fine = window.matchMedia('(pointer: fine)');

  /* ---------- HEADER ---------- */
  var header = doc.querySelector('[data-u-header]');
  var burger = doc.querySelector('[data-u-burger]');
  var menu = doc.querySelector('[data-u-menu]');
  var lastY = 0;
  function onScrollHeader() {
    var y = window.scrollY || 0;
    if (!header) return;
    header.classList.toggle('is-scrolled', y > 24);
    // esconde ao descer rápido, mostra ao subir — some só depois do hero
    if (y > 520 && y > lastY + 6 && !doc.body.classList.contains('u-menu-open')) header.classList.add('is-hidden');
    else if (y < lastY - 4 || y < 520) header.classList.remove('is-hidden');
    lastY = y;
  }
  function setMenu(open) {
    if (!menu || !burger) return;
    menu.classList.toggle('is-open', open);
    doc.body.classList.toggle('u-menu-open', open);
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Fechar menu' : 'Abrir menu');
    if (open) header && header.classList.remove('is-hidden');
  }
  if (burger) burger.addEventListener('click', function () { setMenu(!menu.classList.contains('is-open')); });
  if (menu) menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  /* ---------- REVEAL ---------- */
  var revealEls = doc.querySelectorAll('[data-u-reveal], [data-u-in]');
  if ('IntersectionObserver' in window && !reduce.matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- PARALLAX DE SCROLL ---------- */
  // [data-u-parallax="0.18"] → desloca até 18% da altura da viewport conforme a posição
  var pEls = Array.prototype.slice.call(doc.querySelectorAll('[data-u-parallax]'));
  var hero = doc.querySelector('[data-u-hero]');
  var heroBg = hero && hero.querySelector('.u-hero__bg');
  var heroContent = hero && hero.querySelector('.u-hero__content');
  var ticking = false;

  function frame() {
    ticking = false;
    var vh = window.innerHeight || 800;
    var y = window.scrollY || 0;
    var allow = wide.matches && !reduce.matches;

    pEls.forEach(function (el) {
      if (!allow) { el.style.transform = ''; return; }
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var f = parseFloat(el.getAttribute('data-u-parallax')) || 0.15;
      var p = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
      el.style.transform = 'translate3d(0,' + (-p * f * vh).toFixed(1) + 'px,0)';
    });

    if (hero && heroBg && !reduce.matches) {
      var h = hero.offsetHeight || vh;
      var t = Math.min(1, Math.max(0, y / h));
      if (wide.matches) {
        heroBg.style.transform = 'translate3d(0,' + (t * h * 0.28).toFixed(1) + 'px,0)';
        if (heroContent) { heroContent.style.transform = 'translate3d(0,' + (t * h * 0.12).toFixed(1) + 'px,0)'; heroContent.style.opacity = String(1 - t * 1.4); }
      } else {
        heroBg.style.transform = ''; if (heroContent) { heroContent.style.transform = ''; heroContent.style.opacity = ''; }
      }
    }
  }
  function requestFrame() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }
  window.addEventListener('scroll', function () { onScrollHeader(); requestFrame(); }, { passive: true });
  window.addEventListener('resize', requestFrame, { passive: true });
  onScrollHeader(); requestFrame();

  /* ---------- PARALLAX DE MOUSE NO HERO (profundidade) ---------- */
  if (hero && fine.matches && !reduce.matches) {
    var nuts = Array.prototype.slice.call(hero.querySelectorAll('[data-depth]'));
    var mx = 0, my = 0, cx = 0, cy = 0, raf = null;
    function animate() {
      cx += (mx - cx) * 0.06; cy += (my - cy) * 0.06;
      nuts.forEach(function (n) {
        var d = parseFloat(n.getAttribute('data-depth')) || 0.3;
        n.style.transform = 'translate3d(' + (cx * 40 * d).toFixed(1) + 'px,' + (cy * 30 * d).toFixed(1) + 'px,0)';
      });
      if (Math.abs(mx - cx) > 0.001 || Math.abs(my - cy) > 0.001) raf = window.requestAnimationFrame(animate); else raf = null;
    }
    hero.addEventListener('mousemove', function (e) {
      if (!wide.matches) return;
      var r = hero.getBoundingClientRect();
      mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      my = ((e.clientY - r.top) / r.height - 0.5) * 2;
      if (!raf) raf = window.requestAnimationFrame(animate);
    }, { passive: true });
    hero.addEventListener('mouseleave', function () { mx = 0; my = 0; if (!raf) raf = window.requestAnimationFrame(animate); });
  }

  /* ---------- LINHA DA CADEIA (fábrica → loja) ---------- */
  doc.querySelectorAll('.u-chain').forEach(function (chain) {
    var line = chain.querySelector('.u-chain__line line');
    if (!line) return;
    var len = 2400;
    try { len = line.getTotalLength ? Math.ceil(line.getTotalLength()) : len; } catch (e) {}
    line.style.strokeDasharray = String(len);
    line.style.strokeDashoffset = reduce.matches ? '0' : String(len);
    if (reduce.matches || !('IntersectionObserver' in window)) return;
    var lio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { line.style.strokeDashoffset = '0'; lio.disconnect(); } });
    }, { threshold: 0.3 });
    lio.observe(chain);
  });
})();
